// extracted by mini-css-extract-plugin
export default {"link":"AllReport_link__nqqGI","no_hover":"AllReport_no_hover__gjUZD"};